import { createFileRoute } from "@tanstack/react-router";
import { SiteShell, PageHero } from "@/components/site/SiteShell";
import heroProcess from "@/assets/hero/hero-process.jpg";
import { Section, SectionHeader, CTABand } from "@/components/site/Blocks";
import { buildHead } from "@/lib/seo-head";
import { PageEssentials, PageOutro } from "@/components/site/PageEssentials";

const URL = "/process";
const KEYWORDS = [
  "DSCR loan process",
  "how does a DSCR loan close",
  "investment property loan steps",
  "DSCR loan timeline",
  "business purpose loan underwriting process",
  "DSCR loan closing time",
  "rental loan appraisal process",
  "investor loan application steps",
  "how long to close DSCR loan",
  "DSCR loan scenario review",
].join(", ");

export const Route = createFileRoute("/process")({
  head: () =>
    buildHead({
      title: "Loan Process — 5 Steps to Close | Simply Approved Mortgages",
      description:
        "Scenario → application → appraisal → underwriting → close. Most DSCR loans close in 15–21 business days.",
      url: URL,
      keywords: KEYWORDS,
      breadcrumbs: [
        { name: "Home", url: "/" },
        { name: "Process", url: URL },
      ],
      service: { name: "Investment Property Loan Origination Process" },
    }),
  component: Process,
});

function Process() {
  const steps = [
    { title: "Scenario", body: "Send address, purchase price, and estimated rent. Same-day scenario review on complete applications and initial pricing." },
    { title: "Application", body: "Entity docs, ID, insurance quote, lease or rent schedule." },
    { title: "Appraisal", body: "1007/1025 or 216 form ordered — usually 7–10 business days." },
    { title: "Underwrite", body: "Business-purpose underwriting — typically 10–15 business days." },
    { title: "Close", body: "Wire funds, record deed, servicing set up." },
  ];
  return (
    <SiteShell>
      <PageHero eyebrow="Process" title="5 steps from scenario to close" subtitle="Most DSCR loans close in 15–21 business days from a complete application." image={{ src: heroProcess, alt: "A five-step loan checklist on a desk with house keys and a model rental home" }} />
      <PageEssentials />
      <Section>
        <ol className="mt-4 grid gap-6 md:grid-cols-5">
          {steps.map((s, i) => (
            <li key={s.title} className="rounded-xl border border-border bg-card p-6">
              <div className="text-xs font-semibold text-brand-gold">STEP {i + 1}</div>
              <div className="mt-1 font-display text-lg font-semibold text-foreground">{s.title}</div>
              <p className="mt-2 text-sm text-muted-foreground">{s.body}</p>
            </li>
          ))}
        </ol>
      </Section>
      <CTABand title="Start with a scenario" body="Address, rent, credit — that's most of it." />
    <PageOutro />
      </SiteShell>
  );
}
